//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blankStyle: {
      type: String,
      default: '50vh'
    },
    text: {
      type: String,
      default: '什么都没有~'
    },
    text2: {
      type: String,
      default: ''
    },
    btn: {
      type: String,
      default: ''
    },
    btnShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  components: {},
  created() {
  },
  methods: {
  	btnClick () {
  		this.$emit('btnClick')
  	}
  }
};



// WEBPACK FOOTER //
// ./src/components/cmBlank.vue